import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-announcement-modal-component',
  templateUrl: './announcement-modal-component.component.html',
  styleUrls: ['./announcement-modal-component.component.less']
})
export class AnnouncementModalComponentComponent implements OnInit {

  @Input() htmlContent!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
